import { FunnelChartWrapper, type FunnelStage } from '../charts/FunnelChart'
import { buildDrillRsql } from '../drill'
import { WidgetFrame } from './WidgetFrame'
import { useWidgetData } from './useWidgetData'
import { WIDGET_KEY, type WidgetProps } from './types'
import type { StatusCountBucket } from '../../../types/insights'

const WIDGET_KEY_SELF = WIDGET_KEY.filingsByStatus

/** AC1 — Cases/filings by status. */
export function FilingsByStatusWidget({ filter, skipRefetch, onCrossFilter, onDrill }: WidgetProps) {
  const { status, data, message, retry } = useWidgetData<StatusCountBucket[]>(WIDGET_KEY_SELF, filter, skipRefetch)

  const stages: FunnelStage[] = (data ?? []).map((b) => ({ key: b.status, label: b.label, count: b.count }))
  const frameState = status === 'ok' && stages.length === 0 ? 'empty' : status

  return (
    <WidgetFrame
      title="Filings by status"
      icon="briefcase"
      state={frameState}
      message={message}
      onRetry={retry}
      drill={{ label: 'View filings', onClick: () => onDrill(buildDrillRsql(filter)) }}
    >
      <FunnelChartWrapper
        title="Filings by status"
        stages={stages}
        onStageClick={(stage) => onCrossFilter('currentState', stage.key)}
      />
    </WidgetFrame>
  )
}
